import { supabase } from '@/lib/supabase';

/** Warms React Query cache for IssueReportSection (auto_notify_issues lookup). */
export async function fetchLocationIssueHints(locationId: string) {
  const { data, error } = await supabase
    .from('cleaning_locations')
    .select('auto_notify_issues')
    .eq('id', locationId)
    .maybeSingle();
  if (error) throw error;
  return data;
}

/** Warms inventory rows for the building (Magazyn / property-level lists). */
export async function fetchLocationInventoryWarm(locationId: string) {
  const { data, error } = await supabase
    .from('cleaning_inventory')
    .select('id, item_name, unit, location_id, cleaning_catalog(name, unit)')
    .eq('location_id', locationId)
    .limit(200);
  if (error) throw error;
  return data ?? [];
}
